$(document).ready(function() {

    $(window).load(function(){
      //Google Map          
	      var latlng = new google.maps.LatLng(34.818130, 137.255189);
      var settings = {
        zoom: 17,
        center: new google.maps.LatLng(34.818130, 137.255189), mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        scrollwheel: false,
        draggable: true,
        mapTypeControlOptions: {style: google.maps.MapTypeControlStyle.DROPDOWN_MENU},
        zoomControlOptions: {position: google.maps.ControlPosition.RIGHT_CENTER},
        streetViewControl: true,
        streetViewControlOptions: {position: google.maps.ControlPosition.RIGHT_CENTER},
        fullscreenControlOptions: {position: google.maps.ControlPosition.LEFT_CENTER},
        navigationControl: false,
        navigationControlOptions: {style: google.maps.NavigationControlStyle.SMALL},
        mapTypeId: google.maps.MapTypeId.ROADMAP};
      var map = new google.maps.Map(document.getElementById("map_canvas"), settings); 
      google.maps.event.addDomListener(window, "resize", function() {
        var center = map.getCenter();
        google.maps.event.trigger(map, "resize");
        map.setCenter(center);
      }); 
      var contentString = 
        '<div id="googlemap_wrap">'+
        '  <h3 id="hl_googlemap">カバーイングファクトリー</h3>'+
        '  <h4 id="hlj_googlemap">cover-ing factory</h4>'+
        '  <div id="txt_googlemap">'+
        '    <p>〒443-0021 愛知県蒲郡市三谷町諏訪東10-18<br>10-18 Suwa higashi miya, Gamagori-city, Aichi 443-0021 JAPAN<br><a href="https://www.google.co.jp/maps/place/〒443-0021+愛知県蒲郡市三谷町諏訪東１０%E2%88%92１８/@34.8179491,137.2552281,17z/data=!4m13!1m7!3m6!1s0x6004c655b77344a3:0x30c3e1176230f118!2z44CSNDQzLTAwMjEg5oSb55-l55yM6JKy6YOh5biC5LiJ6LC355S66KuP6Kiq5p2x77yR77yQ4oiS77yR77yY!3b1!8m2!3d34.8181263!4d137.2552182!3m4!1s0x6004c655b77344a3:0x30c3e1176230f118!8m2!3d34.8181263!4d137.2552182?hl=ja?hl=ja" target="_blank">GOOGLE MAP</a></p>'+
        '  </div>'+
        '</div>';
      var infowindow = new google.maps.InfoWindow({
        content: contentString
      }); 
      var companyImage = new google.maps.MarkerImage('//shop.cover-ing-factory.jp/cdn/shop/t/18/assets/marker.png',
        new google.maps.Size(63,68), //マーカーの幅と高さ
        new google.maps.Point(0,0),
        new google.maps.Point(27,50) //マーカーの位置
      );
      var companyPos = new google.maps.LatLng(34.818130, 137.255189); 
      var companyMarker = new google.maps.Marker({
        position: companyPos,
        map: map,
        icon: companyImage,               
        zIndex: 3});
      google.maps.event.addListener(companyMarker, 'click', function() {
        infowindow.open(map,companyMarker);
      });

//color change
	  var stylez = [{"stylers":[{ "saturation": -100 },{ lightness: 0 },{ gamma: 1.0 },{hue: "#fff"}]}];
	  var styledMapOptions = {}
	  var styledMapType =  new google.maps.StyledMapType(stylez,styledMapOptions);
	  map.mapTypes.set('cover-ing factory', styledMapType);
	  map.setMapTypeId('cover-ing factory');

    });
  
});